import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../App.css";

export interface IConfirmDialogParams {
  /**
   * タイトル
   */
  title: string;
  /**
   * メッセージ
   */
  message: string;
  /**
   * OKボタンを押した場合のCalllback
   */
  onOk?: () => void;
  /**
   * Cancelボタンを押した場合のCalllback
   */
  onCancel?: () => void;
}

export interface IConfirmDialogProps extends IConfirmDialogParams {
  /**
   * ダイアログを表示する場合はtrue
   */
  show: boolean;
}

/**
 * 確認ダイアログ
 */
export default function ConfirmDialog(props: IConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} onHide={props.onCancel} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ whiteSpace: "pre-line" }}>{props.message}</div>
        <div className="dialog-buttons">
          <Button
            className="dialog-button"
            variant="primary"
            onClick={props.onOk}
          >
            {t("confirm_ok")}
          </Button>
          <Button
            className="dialog-button"
            variant="secondary"
            onClick={props.onCancel}
          >
            {t("confirm_cancel")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
